__turbopack_context__.v({
  "consentCheckbox": "roldRW_consentCheckbox",
  "consentContent": "roldRW_consentContent",
  "consentLabel": "roldRW_consentLabel",
  "consentRow": "roldRW_consentRow",
  "desc": "roldRW_desc",
  "emailField": "roldRW_emailField",
  "eyebrow": "roldRW_eyebrow",
  "formCol": "roldRW_formCol",
  "formGroup": "roldRW_formGroup",
  "grid": "roldRW_grid",
  "inputRow": "roldRW_inputRow",
  "nameRow": "roldRW_nameRow",
  "privacyLink": "roldRW_privacyLink",
  "section": "roldRW_section",
  "submit": "roldRW_submit",
  "submitError": "roldRW_submitError",
  "success": "roldRW_success",
  "successText": "roldRW_successText",
  "supportText": "roldRW_supportText",
  "title": "roldRW_title",
  "twoColRow": "roldRW_twoColRow",
  "wrap": "roldRW_wrap",
});
